import styled from 'styled-components';
import DetailPrivacy from '../../assets/onboarding/privacy.svg';

const Privacy = styled(DetailPrivacy as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '3.2rem'};
height: ${props => props.height || '3.4rem'};
display: flex;
`;

export default Privacy;
